<form [formGroup]="form" role="form" novalidate>
    <p-autoComplete
        #personnelAutoComplete
        formControlName="searchText"
        [minLength]="minSearchLength"
        [readonly]="isReadOnly"
        delay="500"
        [style]="{ width: '100%' }"
        [inputStyle]="{'text-transform': 'uppercase', width: '100%'}"
        [showEmptyMessage]="showEmptyMessage"
        [emptyMessage]="emptyMessage"
        [placeholder]="placeHolder"
        [suggestions]="list"
        (completeMethod)="onSearch($event)"
        (onSelect)="onSelect($event?.value)"
        (onClear)="onClear()"
        [appendTo]="appendTo"
        [showClear]="showClear"
    >
        <ng-template let-item pTemplate="item">
            <div class="pers-info-row">
                <div class="pers-picture-container" *ngIf="isPictureVisible">
                    <img class="pers-picture" [hidden]="!item.pictureSource" alt="image" src="{{ item.pictureSource }}" />
                </div>
                <div>
                    <div>
                        <span>{{ item.registryNumber ?? '-' }}</span>
                    </div>
                    <div>
                        <span [innerHTML]="getPerSummaryByModel(item) | strong: form.controls['searchText'].value"></span>
                    </div>
                    <div>
                        <span>{{ item.orgHrmPerObjectDefText ?? '' }} / {{ item.posHrmPerObjectDefText ?? '' }}</span>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-autoComplete>
</form>
